export const FOUNDER = {
  name: 'John Hotham',
  role: 'CEO & Founder',
  photo: '/marketing/people/john-hotham.webp',
  linkedin: 'https://www.linkedin.com/in/john-hotham',
  // Draft story for John to edit; no career claims.
  story: [
    "I started Simplif-i because I kept seeing the same problem in growing companies: the work that keeps a business in control is spread across spreadsheets, shared drives, inboxes and outside advisers, and someone senior ends up piecing it together by hand, usually late.",
    "Simplif-i is my answer to that. One connected workspace where information is entered once and carries through to the places that need it, every responsibility has an owner, and leadership can see what needs attention without chasing updates.",
    "I work directly with our founding customers. If you have a question about whether Simplif-i fits how your business runs, you can reach me through LinkedIn or at hello@simplif-i.com.",
  ],
};
